import * as angular from 'angular';
import { bind } from 'app/_decorators/bind.decorator';

class NetworkPointBundleCreateSituationCtrl implements ng.IController {
    constructor(private networkPointSearchService) {
        this.INPUT_ADDON = this.networkPointSearchService.INPUT_ADDON;
    }

    private INPUT_ADDON: {};
    public loggedInUser: LoginResult;
    public networkPoint0: NetworkPointDto;
    public networkPoint1: NetworkPointDto;
    public bundleRequest: BundleChangeRequestDto;
    public editableDirection: Direction;
    public readonly: boolean;

    $onInit() {}

    private setEditableDirection() {
        if (this.networkPoint0.tso0Id == this.loggedInUser.referenceId) {
            this.editableDirection = 'EXIT';
        }
        if (this.networkPoint1.tso0Id == this.loggedInUser.referenceId) {
            this.editableDirection = 'ENTRY';
        }
        if (
            this.networkPoint0.tso0Id == this.loggedInUser.referenceId &&
            this.networkPoint1.tso0Id == this.loggedInUser.referenceId
        ) {
            this.editableDirection = 'BUNDLE';
        }
    }

    @bind
    public onNetworkExitPointSelection(selectedNetworkPoints) {
        this.networkPoint0 = selectedNetworkPoints;
        this.bundleRequest.exitPointRefId = selectedNetworkPoints.id;

        if (this.networkPoint0.tso0Id != this.loggedInUser.referenceId) {
            this.bundleRequest.responderTsoRefId = this.networkPoint0.tso0Id;
        }
        this.setEditableDirection();
    }

    @bind
    public onNetworkEntryPointSelection(selectedNetworkPoints) {
        this.networkPoint1 = selectedNetworkPoints;
        this.bundleRequest.entryPointRefId = selectedNetworkPoints.id;

        if (this.networkPoint1.tso0Id != this.loggedInUser.referenceId) {
            this.bundleRequest.responderTsoRefId = this.networkPoint1.tso0Id;
        }
        this.setEditableDirection();
    }
}

angular.module('app').component('pkpNetworkPointBundleCreateSituation', {
    controller: NetworkPointBundleCreateSituationCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-situation.component.html'),
    bindings: {
        form: '=',
        readonly: '<',
        isCreateMode: '<',
        isDetailsMode: '<',
        loggedInUser: '<',
        networkPoint0: '=',
        networkPoint1: '=',
        bundleRequest: '=',
        editableDirection: '='
    }
});
